module.exports = __webpack_public_path__ + "img/icon65.610db848.png";